export { default as LcRelatedArticles } from './lcRelatedArticles';
export { lcRelatedArticlesType } from './lcRelatedArticles.types';
export { lcRelatedArticlesFragment } from './lcRelatedArticles.fragment';
export { lcRelatedArticlesStandard } from './__fixtures__/lcRelatedArticles';
